import React from "react";

const Disclaimer = () => {
    return (
        <div className="min-h-screen bg-gray-50 text-gray-800">
            <header className="bg-white shadow">
                <div className="max-w-4xl mx-auto px-4 py-4">
                    <h1 className="text-2xl font-bold">Legal Disclaimer for AITrustSignals.com</h1>
                    <p className="text-sm text-gray-500">
                        Last Updated: July 21, 2025
                    </p>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-4 py-8">
                <div className="bg-white rounded-lg shadow p-6 space-y-6 leading-relaxed">
                    <p>
                        Please read this disclaimer carefully before using the AITrustSignals.com website and services (the "Service") operated by AITrustSignals.com ("us", "we", or "our").
                    </p>
                    <p>
                        The information provided by the Service is for general informational purposes only. All information on the Service is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Service.
                    </p>

                    <section>
                        <h2 className="text-lg font-semibold mb-2">AI-Generated Content
                        </h2>
                        <p>
                            The Service utilizes artificial intelligence (AI) and machine learning models to generate content, including but not limited to, analysis, scores, and recommendations. You acknowledge and agree that:
                        </p>
                        <ul className="list-disc pl-6">
                            <li>
                                <strong>AI-generated content may contain errors, inaccuracies, or "hallucinations."</strong> The information provided is not guaranteed to be correct, complete, or up-to-date.
                            </li>
                            <li>
                                <strong>The output of the AI is not a substitute for human judgment.</strong> You are solely responsible for evaluating the accuracy and appropriateness of the generated content for your use case.
                            </li>
                            <li>
                                <strong>You should not rely on the Service as a single source of truth or for professional advice.</strong> Always verify the information provided by the Service with independent sources and consult with qualified professionals for specific advice.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold mb-2">Limitation of Liability</h2>
                        <p>
                            UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SERVICE OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SERVICE. YOUR USE OF THE SERVICE AND YOUR RELIANCE ON ANY INFORMATION ON THE SERVICE IS SOLELY AT YOUR OWN RISK.
                            IN NO EVENT SHALL WE BE LIABLE FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SERVICE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold mb-2">
                            Indemnification
                        </h2>
                        <p>
                            You agree to indemnify, defend, and hold harmless AITrustSignals.com and its affiliates, and their respective officers, directors, employees, agents, and licensors from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) that such parties may incur as a result of or arising from your (or anyone using your account's) violation of these terms.                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold mb-2">No Professional Advice</h2>
                        <p>
                            The information provided by the Service is not intended to be, and shall not be understood or construed as, professional advice. The Service is not a substitute for advice from a qualified professional who is aware of the facts and circumstances of your individual situation.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold mb-2">Changes to This Disclaimer
                        </h2>
                        <p>
                            We reserve the right to make changes to this disclaimer at any time and for any reason. We will alert you about any changes by updating the "Last Updated" date of this disclaimer. You are encouraged to periodically review this disclaimer to stay informed of updates. You will be deemed to have been made aware of, will be subject to, and will be deemed to have accepted the changes in any revised disclaimer by your continued use of the Service after the date such revised disclaimer is posted.                        </p>

                    </section>
                </div>
            </main>

            <footer className="bg-gray-100 border-t mt-8">
                <div className="max-w-4xl mx-auto px-4 py-4 text-sm text-gray-500 text-center">
                    © {new Date().getFullYear()} AITrustSignals.com. All rights reserved.
                </div>
            </footer>
        </div>
    );
}

export default Disclaimer;